import React from 'react';
import DiceDisplayRow from './DiceDisplayRow';

type Props = {
  display: boolean;
  whiteResults: number[][];
  blueResults: number[][];
  redResults: number[][];
  blackResults: number[][];
};

/**
 * Sliding pane showing the results of each individual die
 * @param props
 */
const DiceDisplay: React.FC<Props> = (props) => {
  const {
    display,
    whiteResults,
    blueResults,
    redResults,
    blackResults,
  } = props;
  return (
    <div
      className={`dice-display${display ? ' dice-display--show' : ''}`}
    >
      <DiceDisplayRow title="Attribute Dice" dieResults={whiteResults} colour="#FFF" />
      <DiceDisplayRow title="Skill Dice" dieResults={blueResults} colour="#FFF" />
      <DiceDisplayRow title="Minor Penalty Dice" dieResults={redResults} colour="#FFF" />
      <DiceDisplayRow title="Major Penalty Dice" dieResults={blackResults} colour="#FFF" />
      <div className="dice-display__spacer" />
    </div>
  );
};

export default DiceDisplay;